import { dialogTypes } from '@/constants/alertTypes';
import alertsUtil from '@/util/alertsUtil';
import { get } from 'lodash';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';

const useNonExistedExperimentMsg = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  const nonExistentExperiment = get(
    location,
    'state.nonExistentExperiment',
    false
  );

  useEffect(() => {
    if (!nonExistentExperiment) return;

    dispatch(
      alertsUtil.openErrorDialog(
        dialogTypes.CATCH_ERROR_API,
        'The experiment does not exist anymore'
      )
    );
  }, [dispatch, nonExistentExperiment]);
};

export default useNonExistedExperimentMsg;
